export default function Services() {
  return (
    <section id="services" className="py-24 bg-[#F5F0EB]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-serif mb-4">
            <span className="text-[#C5A572]">(</span> Why Partner With Us <span className="text-[#C5A572]">)</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Comprehensive procurement solutions designed specifically for interior designers
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Card 1 — Discounts */}
          <div className="bg-[#2B2B2B] rounded-3xl p-10 text-white flex flex-col">
            <div className="w-16 h-16 bg-[#C5A572]/20 rounded-full flex items-center justify-center mb-8">
              <i className="ri-percent-line text-3xl text-[#C5A572]"></i>
            </div>
            <div className="mb-4">
              <div className="text-4xl font-bold mb-2 leading-tight">Top Discounts On Premier Trade Brands</div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mt-auto">
              Unlock exclusive trade pricing from premium vendors. Save significantly on every order while maintaining the quality your clients expect.
            </p>
          </div>

          {/* Card 2 — Guaranteed Responses */}
          <div className="bg-[#1C1C1C] rounded-3xl p-10 text-white flex flex-col">
            <div className="w-16 h-16 bg-[#C5A572]/20 rounded-full flex items-center justify-center mb-8">
              <i className="ri-time-line text-3xl text-[#C5A572]"></i>
            </div>
            <div className="mb-4">
              <div className="text-4xl font-bold mb-2 leading-tight">Guaranteed Responses Within 1 Business Day</div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mt-auto">
              We know your time is valuable. Every inquiry gets a real, thoughtful response within one business day — no automated brushoffs, no waiting in the dark.
            </p>
          </div>

          {/* Card 3 — Partner Support */}
          <div className="bg-[#2B2B2B] rounded-3xl p-10 text-white flex flex-col">
            <div className="w-16 h-16 bg-[#C5A572]/20 rounded-full flex items-center justify-center mb-8">
              <i className="ri-user-heart-line text-3xl text-[#C5A572]"></i>
            </div>
            <div className="mb-4">
              <div className="text-4xl font-bold mb-2 leading-tight">You Are Our Partner, Not Just a Number</div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mt-auto">
              Dedicated account management tailored to your specific needs and preferences — a real person who knows your projects and is always in your corner.
            </p>
          </div>

          {/* Card 4 — Damage Claims */}
          <div className="bg-[#1C1C1C] rounded-3xl p-10 text-white flex flex-col">
            <div className="w-16 h-16 bg-[#C5A572]/20 rounded-full flex items-center justify-center mb-8">
              <i className="ri-shield-check-line text-3xl text-[#C5A572]"></i>
            </div>
            <div className="mb-4">
              <div className="text-4xl font-bold mb-2 leading-tight">Hassle-Free Damage Claims</div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mt-auto">
              We handle every damage claim from start to finish. If something arrives wrong, we step in immediately — coordinating with vendors, managing replacements, and keeping your project on track without the stress.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
